import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterBikesLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Services',
            subNav: [
                {
                    url: '/bikes/insurance',
                    displayText: 'Bike insurance',
                    routerLink: false,
                },
                {
                    url: '/bikes/finance',
                    displayText: 'Bike finance',
                    routerLink: false,
                },
                {
                    url: '/bikes/vehicle-check',
                    displayText: 'Vehicle check',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Private customers',
            subNav: [
                {
                    url: '/bikes/sell',
                    displayText: 'Sell my bike',
                    routerLink: false,
                },
                {
                    url: '/bikes/sell-my-bike/advertising-prices',
                    displayText: 'Advertising costs',
                    routerLink: false,
                },
                {
                    url: '/safety_and_security_centre',
                    displayText: 'Buying & selling safely online',
                    routerLink: false,
                },
                {
                    url: '/terms-and-conditions/advertising',
                    displayText: 'Terms & conditions',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/bikes/motorcycles/browse-all-makes',
                    displayText: 'All bikes makes',
                    routerLink: false,
                },
                {
                    url: '/bikes/motorcycles',
                    displayText: 'New & used bikes',
                    routerLink: false,
                },
                {
                    url: '/bikes/content',
                    displayText: 'Bike reviews',
                    routerLink: false,
                },
                {
                    url: '/bikes/motorcycle-dealers',
                    displayText: 'Bike dealers',
                    routerLink: false,
                },
                {
                    url: '/bikes/best-motorbike-awards',
                    displayText: 'Best bike awards',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterBikesLinks;
